import { z } from "zod/v4";

import { ExperienceAnalysisHistoryDtoSchema } from "../../../dtos/ai";

export const AiGetExperienceAnalysisHistoryPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type AiGetExperienceAnalysisHistoryPathParamType = z.infer<
  typeof AiGetExperienceAnalysisHistoryPathParamSchema
>;

export const AiGetExperienceAnalysisHistoryResponseSchema = z.object({
  history: ExperienceAnalysisHistoryDtoSchema.array(),
});

export type AiGetExperienceAnalysisHistoryResponseBodyType = z.infer<
  typeof AiGetExperienceAnalysisHistoryResponseSchema
>;
